<app-header
  class="layout-header"
  [menuToggleEnabled]="true"
  [compactMode]="!menuOpened"
  (menuToggle)="menuOpened = !menuOpened"
  [title]="appInfo.title"
></app-header>

<dx-drawer
  class="layout-body"
  position="before"
  [closeOnOutsideClick]="shaderEnabled"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [maxSize]="sidebarMaxSize"
  [shading]="shaderEnabled"
  [(opened)]="menuOpened"
>
  <side-navigation-menu
    [compactMode]="!menuOpened"
    [selectedItem]="selectedRoute"
    [width]="sidebarMaxSize"
    class="dx-swatch-additional"
    *dxTemplate="let dataMenu of 'panel'"
    (selectedItemChanged)="navigationChanged($event)"
    (openMenu)="navigationClick()"
  >
    <app-footer
      >Copyright © {{ appInfo.currentYear }} · IONICS</app-footer
    >
    <!-- Resize handle: barra delgada con grip a la derecha del panel para arrastrar -->
    <div
      class="sidebar-resize-handle"
      role="separator"
      aria-orientation="vertical"
      [title]="'sidebar.arrastrarRedimensionar' | translate"
      (mousedown)="startResize($event)"
      (touchstart)="startResize($event)"
    >
      <span class="grip"></span>
    </div>
  </side-navigation-menu>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</dx-drawer>
